import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Icon, Button, Modal } from '@arnsbogroup/react-voicearchive'
import classNames from 'classnames'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

const ConfirmModal = NiceModal.create(() => {
  const modal = useModal()
  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => {
        modal.resolve()
        modal.remove()
      }}
      dialogPanelClasses="max-w-xl overflow-x-scroll"
    >
      <div className="space-y-4">
        <h2 className="font-medium">
          This order is a draft.
        </h2>

        <h4 className="font-medium">
          Please confirm with the customer first before converting to an order.
        </h4>

        <div className="flex justify-between items-center">
          <Button onClick={() => modal.remove()} >
            Cancel
          </Button>

          <Button
            variant="outline"
            state="negative"
            onClick={() => {
              modal.resolve()
              modal.remove()
            }}
          >
            Yes, convert order
          </Button>
        </div>
      </div>
    </Modal>
  )
})

export default ({ order, readOnly, refetch, as = null, ...props }) => {
  const [loading, setLoading] = useState(false)
  const Component = as || Button

  const onConfirm = () => {
    NiceModal
      .show(ConfirmModal)
      .then(onConvert)
  }

  const onConvert = () => {
    setLoading(true)
    fetch(`/rest/v2/order/${order.uid}/draft-to-order`, { method: 'PUT'})
      .then((response) => response.json())
      .then(({ success, errors }) => {
        setLoading(false)

        if (success) {
          return refetch()
        } else {
          const errorSentences = Object.entries(errors)
            .flatMap(([key, value]) => value);
          toastr.error(errorSentences)
        }
      })
      .catch((error) => toastr.error(error))
  }

  return (
    <Component size="sm" {...props} disabled={loading} onClick={onConfirm}>
      { loading ? (
        <span>Converting...</span>
      ) : (
        <span>Convert to order</span>
      ) }
    </Component>
  )
}
